module.exports = __webpack_public_path__ + "img/sos_start_ind.4c4d6768.png";